// src/analytics/useSpaPageviews.ts
import { useEffect } from "react"
import { useLocation } from "react-router-dom"
import { pushPageView } from "./pushPageView"

declare global {
  interface Window {
    dataLayer?: any[]
  }
}

export default function useSpaPageviews() {
  const loc = useLocation()
  useEffect(() => {
    pushPageView()
  }, [loc.pathname, loc.search, loc.hash])
}
